import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  BigImageBlock,
  ImageTextShadow,
  ImageTextPrint,
  CaptionBlockWrapper,
  SliderWithCaptionWrap,
  SliderImageArea,
  SliderCaptionText,
} from '../../styles/LongreadBlockRenderer.styles';
import { invertColor } from '../../utils/colorUtils';

interface SliderBlockProps {
  block: any;
  backgroundColor?: string;
}

export const SliderBlock: FC<SliderBlockProps> = ({ block, backgroundColor }) => {
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];
  const attachmentText = firstAttachment?.text && firstAttachment.text !== 'string' ? firstAttachment.text : '';
  const attachmentTextPosition = firstAttachment?.textPosition || '';
  const isAttachmentCaption = ['caption', 'caption-bottom'].includes(attachmentTextPosition);
  const overlayText = block.overText || block.text || (!isAttachmentCaption ? attachmentText : '');
  const hasText = !!overlayText;
  const textPosition = (block.overText || block.text)
    ? (block.titlePosition || 'bottom')
    : (attachmentTextPosition || block.titlePosition || 'bottom');
  const resolvedCaption = block.caption || (isAttachmentCaption ? attachmentText : '');
  const hasCaption = !!resolvedCaption;

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);

  return (
    <LongreadBlockWrapper>
      <SliderWithCaptionWrap>
        <SliderImageArea>
          <BigImageBlock data-fullscreen-image>
            {files && files.length > 0 && (
              <ResizedImageEnhanced files={files} />
            )}
            {hasText && (
              <>
                <ImageTextShadow position="bottom" />
                <ImageTextPrint position={textPosition}>
                  <FormatLinkedText text={overlayText} />
                </ImageTextPrint>
              </>
            )}
          </BigImageBlock>
        </SliderImageArea>
        {hasCaption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <SliderCaptionText>
              <FormatLinkedText text={resolvedCaption} />
            </SliderCaptionText>
          </CaptionBlockWrapper>
        )}
      </SliderWithCaptionWrap>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  BigImageBlock,
  ImageTextShadow,
  ImageTextPrint,
  CaptionBlockWrapper,
  SliderWithCaptionWrap,
  SliderImageArea,
  SliderCaptionText,
} from '../../styles/LongreadBlockRenderer.styles';
import { invertColor } from '../../utils/colorUtils';

interface SliderBlockProps {
  block: any;
  backgroundColor?: string;
}

export const SliderBlock: FC<SliderBlockProps> = ({ block, backgroundColor }) => {
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];
  const attachmentText = firstAttachment?.text && firstAttachment.text !== 'string' ? firstAttachment.text : '';
  const attachmentTextPosition = firstAttachment?.textPosition || '';
  const isAttachmentCaption = ['caption', 'caption-bottom'].includes(attachmentTextPosition);
  const overlayText = block.overText || block.text || (!isAttachmentCaption ? attachmentText : '');
  const hasText = !!overlayText;
  const textPosition = (block.overText || block.text)
    ? (block.titlePosition || 'bottom')
    : (attachmentTextPosition || block.titlePosition || 'bottom');
  const resolvedCaption = block.caption || (isAttachmentCaption ? attachmentText : '');
  const hasCaption = !!resolvedCaption;

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);

  return (
    <LongreadBlockWrapper>
      <SliderWithCaptionWrap>
        <SliderImageArea>
          <BigImageBlock data-fullscreen-image>
            {files && files.length > 0 && (
              <ResizedImageEnhanced files={files} />
            )}
            {hasText && (
              <>
                <ImageTextShadow position="bottom" />
                <ImageTextPrint position={textPosition}>
                  <FormatLinkedText text={overlayText} />
                </ImageTextPrint>
              </>
            )}
          </BigImageBlock>
        </SliderImageArea>
        {hasCaption && (
          <CaptionBlockWrapper textColor={defaultTextColor}>
            <SliderCaptionText>
              <FormatLinkedText text={resolvedCaption} />
            </SliderCaptionText>
          </CaptionBlockWrapper>
        )}
      </SliderWithCaptionWrap>
    </LongreadBlockWrapper>
  );
};
